export const pageheader = {
  root: {
    background: "{surface.bg-grey}",
    padding: "{padding.24} {padding.16}",
    gap: "{gap.8}",
  },
  header: {
    gap: "{gap.4}",
  },
  caption: {
    fontSize: "{typography.page.heading.font.size}",
    fontLeading: "{typography.page.heading.font.leading}",
    fontWeight: "{typography.page.heading.font.weight}",
    color: "{typography.page.heading.color}",
    mobileFontSize: "{typography.mobile.page.heading.font.size}",
    mobileFontLeading: "{typography.mobile.page.heading.font.leading}",
    mobileFontWeight: "{typography.mobile.page.heading.font.weight}",
  },
  description: {
    fontSize: "{typography.body.text.regular.font.size}",
    fontLeading: "{typography.body.text.regular.font.leading}",
    fontWeight: "{typography.body.text.regular.font.weight}",
    mobileFontSize: "{typography.mobile.body.text.regular.font.size}",
    mobileFontLeading: "{typography.mobile.body.text.regular.font.leading}",
    mobileFontWeight: "{typography.mobile.body.text.regular.font.weight}",
  },
};
